<div id="shapes-sidebar">
    @if (graph) {
        <mat-accordion [multi]="true" [displayMode]="'flat'">
            @for (
                kv of shapes | keyvalue: keepOrder;
                track trackBy($index, kv);
                let isFirst = $first
            ) {
                <mat-expansion-panel class="panel" [expanded]="isFirst">
                    <mat-expansion-panel-header
                        class="header"
                        [collapsedHeight]="'35px'"
                        [expandedHeight]="'35px'"
                    >
                        <mat-panel-title
                            [matTooltip]="'shapePanelTooltip' | t"
                        >
                            {{ kv.key }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="content">
                        @for (shape of kv.value; track shape) {
                            @if (shape.useImage) {
                                <img
                                    src="{{ shape.image }}"
                                    class="shape"
                                    #element
                                    (Create)="makeDraggable(shape, element)"
                                    (click)="onShapeClick($event, shape)"
                                    [matTooltip]="shape.name"
                                />
                            } @else {
                                @if (shape.svg) {
                                    <div
                                        class="shape"
                                        [innerHTML]="shape.safeSvg"
                                        #element
                                        (Create)="makeDraggable(shape, element)"
                                        (click)="onShapeClick($event, shape)"
                                        [matTooltip]="shape.name"
                                    ></div>
                                }
                            }
                        }
                    </div>
                </mat-expansion-panel>
            }
        </mat-accordion>
    }
</div>
